module.exports = __webpack_public_path__ + "static/media/img4.11a71ad5.jpg";